import DOMPurify from "dompurify";

const CONTROL_CHARACTER_PATTERN = /[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F]/;
const CONTROL_CHARACTERS = /[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F]/g;

export function sanitizePlainText(value, { maxLength = 10000, trim = true } = {}) {
  const withoutMarkup = DOMPurify.sanitize(String(value ?? ""), {
    ALLOWED_TAGS: [],
    ALLOWED_ATTR: [],
    KEEP_CONTENT: true,
  }).replace(CONTROL_CHARACTERS, "");
  const normalized = trim ? withoutMarkup.trim() : withoutMarkup;
  return normalized.slice(0, maxLength);
}

export function getSafeExternalUrl(value, { httpsOnly = true } = {}) {
  if (typeof value !== "string" || CONTROL_CHARACTER_PATTERN.test(value)) return "";
  try {
    const url = new URL(value.trim());
    const allowedProtocols = httpsOnly ? ["https:"] : ["https:", "http:"];
    if (!allowedProtocols.includes(url.protocol) || url.username || url.password) return "";
    return url.href;
  } catch {
    return "";
  }
}

export function openSafeExternalUrl(value, target = "_blank") {
  const url = getSafeExternalUrl(value);
  if (!url) return false;
  const opened = window.open(url, target, "noopener,noreferrer");
  if (opened) opened.opener = null;
  return true;
}

export function assignSafeExternalUrl(value) {
  const url = getSafeExternalUrl(value);
  if (!url) throw new Error("The external destination is not valid.");
  window.location.assign(url);
}
